export interface MaterialType {
    id?: string; // Cambiado a string para coincidir con la API
    centerGroupId?: number;
    name: string;
    subcategories: MaterialSubcategory[];
    createdAt?: Date;
    updatedAt?: Date;
}

export interface MaterialSubcategory {
    id?: number;
    name: string;
    materialTypeId: number;
}

// Interface para la respuesta de la API
export interface MaterialTypeApiResponse {
    id: string;
    centerGroupId: number;
    name: string;
    subCategories: string[];
}

// Interface para crear/actualizar en la API
export interface MaterialTypeCreateRequest {
    centerGroupId: number;
    name: string;
    subCategories: string[];
}

// Interface para actualizar en la API (incluye ID)
export interface MaterialTypeUpdateRequest {
    id: string;
    centerGroupId: number;
    name: string;
    subCategories: string[];
}

export interface MaterialTypeFormData {
    name: string;
    subcategories: string[];
}